import { labelContract } from './label.contract';
import { sequenceContract } from './sequence.contract';
import { unassignedActivityContract } from './unassignedActivity.contract';
import { milestoneContract, milestoneStreamRoute } from './milestone.contract';
import { sequenceItemContract } from './sequenceItem.contract';
import { activitiesGroupContract, activitiesGroupStreamRoute } from './activitiesGroup.contract';
import { activityContract, activityStreamRoute } from './activity.contract';
import { externalActivityContract } from './externalActivity.contract';

// Individual re-exports (for route files importing specific contracts)
export { labelContract } from './label.contract';
export { sequenceContract } from './sequence.contract';
export { unassignedActivityContract } from './unassignedActivity.contract';
export { milestoneContract, milestoneStreamRoute } from './milestone.contract';
export { sequenceItemContract } from './sequenceItem.contract';
export { activitiesGroupContract, activitiesGroupStreamRoute } from './activitiesGroup.contract';
export { activityContract, activityStreamRoute } from './activity.contract';
export { externalActivityContract } from './externalActivity.contract';
export type { GetStreamActivitiesQuery } from './activity.contract';

// Aggregated export for service client creation
export const activitiesContracts = {
	labelContract,
	sequenceContract,
	unassignedActivityContract,
	milestoneContract,
	sequenceItemContract,
	activitiesGroupContract,
	activityContract,
	externalActivityContract,
};
